// Lista de magias e runas (gerada por tools/build_spells.py a partir do TibiaWiki e da lista do cliente).
import type { VocationId } from './vocations.js';

export interface SpellArea { type: 'single' | 'self' | 'circle' | 'target-circle' | 'wave' | 'beam' | 'chain'; radius: number; range: number; count?: number }

/** Fórmula oficial (Canary/Global): expressões em level, maglevel, skill, attack, factor e flat. */
export interface SpellExpr { kind: 'magic' | 'skill'; min: string; max: string }

export interface SpellDef {
  name: string; words: string; kind: 'instant' | 'rune';
  group: 'attack' | 'healing' | 'support' | 'summon' | 'supply' | 'field' | 'party';
  vocations: VocationId[]; level: number; ml: number; mana: number; soul: number; premium: boolean;
  cooldown: number; groupCooldown: number; element: string; areaText: string; area: SpellArea;
  bp: number; scale: 'magic' | 'weapon' | 'distance' | 'shield' | '';
  icon: number; item?: number | null; price?: number | null; formula?: [number, number, number, number];
  /** O jogo já executa esta magia/runa em combate. */
  usable: boolean;
  /** só para promovidos (Challenge, Enchant Staff, Conjure Power Bolt) */
  promotion?: boolean;
  /** dados oficiais (Canary): efeito no alvo/área, projétil, área (matriz virada para o norte), direcional, fórmula, dano contínuo */
  effect?: number | null; missile?: number | 'weapon' | null; grid?: number[][] | null; dir?: boolean; needTarget?: boolean;
  expr?: SpellExpr | null; dot?: number[][] | null; chain?: number | null;
  /** monk: builder gera 1 de Harmony; spender gasta toda a Harmony com dano/cura maiores */
  monk?: 'builder' | 'spender';
  /** mana gasta ao USAR a runa (paralyze rune: 1400, como no Global) */
  useMana?: number;
}

export const AREA_NAMES: Record<SpellArea['type'], string> = {
  single: 'Alvo único', self: 'Em si mesmo', circle: 'Área ao redor do personagem', 'target-circle': 'Área ao redor do alvo',
  wave: 'Onda à frente', beam: 'Raio à frente', chain: 'Em cadeia',
};
export const GROUP_NAMES: Record<string, string> = {
  attack: 'Ataque', healing: 'Cura', support: 'Suporte', summon: 'Invocação', supply: 'Conjurar', field: 'Campo', party: 'Grupo',
};
export const ELEMENT_NAMES: Record<string, string> = {
  physical: 'físico', fire: 'fogo', ice: 'gelo', energy: 'energia', earth: 'terra', death: 'morte', holy: 'sagrado', heal: 'cura',
};

/** Pode usar? Devolve o motivo se não puder. Runas pedem o magic level; magias, o level. */
export function spellBlock(s: SpellDef, voc: VocationId, level: number, ml: number, promotion = 0): string | null {
  if (!s.vocations.includes(voc)) return 'não é da sua vocation';
  if (s.promotion && promotion < 1) return 'precisa de promotion';
  if (level < s.level) return `level ${s.level}`;
  if (s.kind === 'rune' && ml < s.ml) return `magic level ${s.ml}`;
  return null;
}
